<agpr-dialog-container
    [id]="id + '.dateQueryDialog'"
    [heading]="header"
    (close)="cancel()"
    class="agpr-clickOutsideExcluded"
>
    <agpr-scroll-panel>
        <agpr-date-range-selector
            [id]="id"
            header="Monitoring.dateQueryDialog.label.dateRange"
            [options]="options"
            [(ngModel)]="selectedOption"
            [dateRange]="dateRange"
            [useToDate]="useToDate"
            [dateTypeOptions]="dateTypeOptions"
            [setEndOfDayTime]="setEndOfDayTime"
            [hideDateTypeSelection]="hideDateTypeSelection"
            (ngModelChange)="this.selectedOption = $event"
        ></agpr-date-range-selector>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.applyButton'"
            label="Core.button.apply"
            [style]="buttonTypes.primary"
            (click)="apply()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
